import React from 'react';

import { SplitLayout } from '@rockerbox/styleguide';
import { Header } from 'semantic-ui-react';

import { PixelCnameDomain, AllowedDomains, ExcludedDomains, ViewAccessWrapper } from '../../components';
import { SETTINGS_DOMAINS } from '../../constants/views';

const Domains = () => (
  <>
    <Header
      as="h1"
      content="Manage Your Custom Domain"
    />
    <PixelCnameDomain />
    <SplitLayout
      rightWidth={8}
      leftWidth={8}
      rightContent={<ExcludedDomains />}
      leftContent={<AllowedDomains />}
    />
  </>
);

const DomainsWrapper = () => (
  <ViewAccessWrapper
    viewName={SETTINGS_DOMAINS}
    viewComponent={<Domains />}
  />
);

export default DomainsWrapper;
